export default "__VITE_ASSET__BxJVtSGJ__"